import { CashFlowFrameDialogService } from './cashFlowFrameDialogForm';

const cashFlowIframeDialogMembershipBillingInformation = {

    cashFlowFrameDialogService: null,

    init: function() {
        this.cashFlowFrameDialogService = new CashFlowFrameDialogService();
    },

    openDialog: function(cashFlowIframeDialogOptions, callback) {
        this.init();

        this.cashFlowFrameDialogService.open(
            function(form, data) {
                callback(data);
            },
            {
                dialogOptions: {
                    title: '<b>Enter Credit/Debit Card to Store on File</b>',
                    caProUI: true,
                    staticForm: false,
                },
                cashFlowIframeDialogOptions: cashFlowIframeDialogOptions
            }
        );
    },
};

export default cashFlowIframeDialogMembershipBillingInformation;
